import {db} from "./db";
import axios from "axios";

let force_dev_api = 0;
let apiInUse;

if (force_dev_api || window.location.href.includes("dev")) {
    apiInUse = "https://api.dev.promptus.ai"
} else {
    apiInUse = "https://api.promptus.ai"
}

export const getAPIHost = async (apiState, apiDispatch) => {
    if (apiState) {
        if (!apiState.online) {
            let PROMPTUS_API = `http://${process.env.REACT_APP_PROMPTUS_LOCALHOST}`;
            await db.settings.where('key').equals('api_host').first(setting => {
                let apiHost = "";
                if (setting.key === "api_host") apiHost = setting.value;
                if (apiHost) {
                    PROMPTUS_API = `${apiHost}`;
                }
                apiDispatch({type: "setHost", host: PROMPTUS_API});
                apiDispatch({type: 'setActiveGPU', server: false})
                apiDispatch({type: 'setActiveCPU', server: false})

            });
            return;
        }
        apiDispatch({type: "setHost", host: apiInUse});
    }
};

export const getServerStatus = async (apiState, generateStatusDispatch) => {
    return await fetch(`${apiState.host}/api/generate/is-busy`)
        .then(response => response.json())
        .then(data => {
            console.log('server busy status', data);
            generateStatusDispatch({type: 'setServerStatus', serverStatus: data});
            return data;
        })
        .catch(error => {
            console.error("Error getting server status:", error);
            generateStatusDispatch({type: 'error', message: 'Could not reach server'});
        });
}

export const getModels = async (apiState, generateStatusDispatch) => {
    try {
        const response = await axios.get(`${apiState.host}/api/generate/get-models`);
        return response.data;
    } catch (error) {
        console.error("Error getting models:", error);
        generateStatusDispatch({ type: 'error', message: 'Could not fetch models' });
    }
};

export const getLoras = async (apiState, generateStatusDispatch) => {
    if (!apiState.host.includes('localhost')) {
        console.log("Cannot fetch loras from server yet.");
        return { loras: [] };
    }
    try {
        const response = await axios.get(`${apiState.host}/api/generate/get-loras`);
        return response.data;
    } catch (error) {
        console.error("Error getting loras:", error);
        generateStatusDispatch({ type: 'error', message: 'Could not fetch loras' });
    }
};

export const generatePrompt = async (prompt, apiState, generateStatusDispatch) => {
    try {
        const response = await axios.post(`${apiState.host}/api/generate`, prompt, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error generating prompt:", error);
        generateStatusDispatch({ type: 'error', message: 'An unexpected error occurred' });
    }
};

export const getProgress = async (uid, apiState, generateStatusDispatch) => {
    if (uid) {
        try {
            const response = await axios.get(`${apiState.host}/api/generate/progress?uid=${uid}`);
            return response.data;
        } catch (error) {
            if (error.name === 'AbortError') return error;
            console.error("Error getting progress:", error);
            generateStatusDispatch({ type: 'error', message: 'An unexpected error occurred' });
        }
    }
};

export const getGenerateOutput = async (jobUid, outputId) => {
    try {
        const response = await axios.get(`${apiInUse}/api/generate/output/${jobUid}/${outputId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting generate output:", error);
    }
};

export const cancelJob = async (uid, account_no, apiState, generateStatusDispatch)=> {
    try {
        const response = await axios.get(`${apiState.host}/api/generate/cancel`, {
            params: { account_no, uid }
        });
        return response.data;
    } catch (error) {
        console.error("Error canceling job:", error);
        generateStatusDispatch({ type: 'error', message: 'Could not process cancel request' });
    }
}

export const signin = async (email, password)=> {
    try {
        const response = await axios.post(`${apiInUse}/api/profile/signin`, { email, password }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error signing in:", error);
    }
}

export const accountNosignin = async (accountNo)=> {
    try {
        const response = await axios.get(`${apiInUse}/api/profile/${accountNo}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting account no:", error);
    }
}

export const getTokens = async (accountNo)=> {
    try {
        const response = await axios.get(`${apiInUse}/api/profile/${accountNo}/credits`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        console.log("Tokens: ", response.data);
        return response.data;
    } catch (error) {
        console.error("Error getting tokens:", error);
    }
}

export const getAccountFromGoogle = async (email)=> {
    try {
        const response = await axios.post(`${apiInUse}/api/profile/google-signin`, { email }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting account from google:", error);
    }
}

export const updateAccount = async (blob, accountNo, token, metadata) => {
    try {
        const response = await axios.post(`${apiInUse}/api/images/update/${accountNo}`, {
            alias: null,
            token,
            password: null,
            verificationToken: null,
            images: blob,
            metadata
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating account:", error);
    }
};

export const deleteCollectionImage = async (accountNo, hash) => {
    try {
        const response = await axios.post(`${apiInUse}/api/images/delete/${accountNo}/${hash}`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting collection image:", error);
    }
};

export const updateAliasAccount = async (username, accountNo) => {
    try {
        const response = await axios.post(`${apiInUse}/api/profile/${accountNo}/update`, {
            alias: username,
            token: null,
            password: null,
            verificationToken: null,
            images: null
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating alias account:", error);
    }
};

export const getPublicGalleries = async () => {
    try {
        const response = await axios.get(`${apiInUse}/api/publicGalleries`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting public galleries:", error);
    }
};

export const generateOutput = async (directory, image) => {
    try {
        const response = await axios.post(`${apiInUse}/api/output`, { directory, image }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error generating output:", error);
    }
};

export const registerHostingService = async (promptusID, emailAddress, alias) => {
    try {
        const response = await axios.post(`${apiInUse}/whmcs/register`, {
            id: promptusID,
            email: emailAddress,
            alias
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error registering hosting service:", error);
    }
};

export const changeImageVisibility = async (accountNo, hash, publicValue) => {
    try {
        const response = await axios.post(`${apiInUse}/api/images/public/${accountNo}/${hash}/${publicValue}`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error changing image visibility:", error);
    }
};

export const getCollectionHashes = async (accountNo) => {
    try {
        const response = await axios.get(`${apiInUse}/api/images/collection/${accountNo}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting collection hashes:", error);
    }
};

export const getCollectionImage = async (accountNo, hash) => {
    try {
        const response = await axios.get(`${apiInUse}/api/images/collection/${accountNo}/${hash}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting collection image:", error);
    }
};

export const updateImageTags = async (accountNo, hash, tag) => {
    try {
        const response = await axios.post(`${apiInUse}/api/images/tag/${accountNo}/${hash}`, { tag }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating image tags:", error);
    }
};

export const nodeTestAdd = async (accountNo, testNode) => {
    try {
        const response = await axios.post(`${apiInUse}/api/node-test/add/${accountNo}/${testNode}`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error adding node test:", error);
    }
};

export const nodeTestGet = async (accountNo) => {
    try {
        const response = await axios.get(`${apiInUse}/api/node-test/get/${accountNo}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        let data = response.data;
        if ('data' in data) {
            data = data.data;
            console.log('nodeTestGet removed redundant data wrapper');
        }
        return data;
    } catch (error) {
        console.error("Error getting node test:", error);
    }
};

export const nodeTestDelete = async (accountNo, testNode) => {
    try {
        const response = await axios.post(`${apiInUse}/api/node-test/delete/${accountNo}`, {}, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting node test:", error);
    }
};

export const getImageMetadata = async (accountNo, hash) => {
    try {
        const response = await axios.get(`${apiInUse}/api/images/metadata/${accountNo}/${hash}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting image metadata:", error);
    }
};

export const revealLocator = async (inscriptionID) => {
    try {
        const response = await axios.get(`https://ordinals.com/content/${inscriptionID}`);
        return response.data;
    } catch (error) {
        console.error("Error revealing locator:", error);
    }
};

export const getPromptFileData = async (accountNo, uid) => {
    try {
        const response = await axios.get(`${apiInUse}/api/images/prompt-file/${accountNo}/${uid}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting prompt file data:", error);
    }
};

export const getImageDescription = async (accountNo, hash, image) => {
    let url = `${apiInUse}/api/images/description/${accountNo}`;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
        }
    };

    if (hash !== "") {
        console.log("Requesting description via GET and hash");
        url += `/${hash}`;
        options.method = "GET";
    } else if (image) {
        console.log("Requesting description via POST and image");
        options.method = "POST";
        options.body = JSON.stringify({ image });
    } else {
        throw new Error("Either hash or image must be provided");
    }

    try {
        const response = await axios({
            url,
            method: options.method,
            headers: options.headers,
            data: options.body
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching image description:', error);
        throw error; // Re-throw the error to handle it further up in the call stack if necessary
    }
};

export const isLocalServerBusy = async (apiState) => {
    try {
        const response = await axios.get(`${apiState.host}/api/generate/is-busy`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error checking if local server is busy:", error);
    }
};

export const getRecommendedSettings = async () => {
    try {
        const response = await axios.get(`${apiInUse}/api/settings/get-recommended`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting recommended settings:", error);
    }
};

export const shareToSocialMedia = async (accountNo, image, url) => {
    try {
        const response = await axios.post(`${apiInUse}/api/images/share/${url}/${accountNo}`, { image }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error sharing to social media:", error);
    }
};

export const updateOpenAIKey = async (openAIKey, accountNo) => {
    try {
        const response = await axios.post(`${apiInUse}/api/profile/${accountNo}/update`, {
            openAIKey,
            token: null,
            password: null,
            verificationToken: null,
            images: null,
            alias: null
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating openAI key:", error);
    }
};

export const setReceived = async (jobUid, outputUid) => {
    try {
        const response = await axios.post(`${apiInUse}/api/generate/received/${jobUid}/${outputUid}`, {  }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error setting received:", error);
    }
};

export const getUndeliveredImages = async (accountNo) => {
    try {
        const response = await axios.get(`${apiInUse}/api/images/undelivered/${accountNo}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting undelivered images:", error);
    }
};

export const getWhmcsData = async (accountNo) => {
    try {
        const response = await axios.get(`${apiInUse}/api/whmcs/details/${accountNo}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting whmcs data:", error);
    }
};